import { render, staticRenderFns } from "./DDdetail.vue?vue&type=template&id=0d3d6fbc&scoped=true&"
import script from "./DDdetail.vue?vue&type=script&lang=js&"
export * from "./DDdetail.vue?vue&type=script&lang=js&"
import style0 from "./DDdetail.vue?vue&type=style&index=0&id=0d3d6fbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d6fbc",
  null
  
)

export default component.exports